import $ from 'jquery'

export function init() {
  // How it works page: fixed footer
  if ($(".js-floating-choice").length && $(".js-floating-choice-trigger").length) {
    var distanceTop = $(".js-floating-choice-trigger").offset().top;
    var windowHeight = $(window).innerHeight();
    $(window).scroll(function () {
      var st = $(this).scrollTop();
      if (st > 200) {
        $(".js-floating-choice").addClass("fixed");
      }
      if ((st + windowHeight) > distanceTop) {
        $(".js-floating-choice").removeClass("fixed");
      }
    });
  }
}